var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRegulatorEscalatorImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 308,
    height: 270,
    viewBox: "0 0 308 270",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.77905 174.116L127.62 244.474L298.221 145.166L182.486 76.2825L9.77905 174.116Z",
    fill: "url(#paint0_linear_727_30324)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M215.621 152.595L127.294 203.657L19.334 141.026L107.631 89.9753L215.621 152.595Z",
    fill: "#4E342E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M107.12 90.2715L19.231 141.085L107.161 191.852L107.12 90.2715Z",
    fill: "#005478"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M127.263 238.376L19.126 175.481L107.135 123.582L215.621 187.189L127.263 238.376Z",
    fill: "#023248"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M166.091 113.331L57.749 50.1155L57.814 137.937L166.087 199.818L166.091 113.331Z",
    fill: "#F79E8D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M78.624 62.2957L90.53 69.2417L166.088 182.919V193.884L78.624 62.2957Z",
    fill: "#F25C3E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M99.222 74.3145L111.127 81.2605L166.089 163.949V174.913L99.222 74.3145Z",
    fill: "#F25C3E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M166.091 126.012L166.09 136.976L140.417 98.3516L152.322 105.297L166.091 126.012Z",
    fill: "#F25C3E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M119.82 86.3325L131.725 93.2795L166.09 144.982L166.089 155.946L119.82 86.3325Z",
    fill: "#F25C3E"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7629 68.8505L57.755 57.8735L143.536 186.93L131.784 180.213L57.7629 68.8505Z",
    fill: "#F25C3E"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M58.027 50.2776L69.932 57.2246L163.87 198.551L152.116 191.834L58.027 50.2776Z",
    fill: "#F25C3E"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M62.202 140.446L57.814 137.938L57.8099 133.84L62.202 140.446Z",
    fill: "#F25C3E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M161.015 110.369L166.091 113.332V118.006L161.015 110.369Z",
    fill: "#F25C3E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M57.777 87.8415L57.769 76.8655L123.202 175.308L111.45 168.591L57.777 87.8415Z",
    fill: "#F25C3E"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M57.79 106.834L57.783 95.8567L102.869 163.689L91.116 156.971L57.79 106.834Z",
    fill: "#F25C3E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M57.804 125.825L57.796 114.848L82.536 152.067L70.783 145.35L57.804 125.825Z",
    fill: "#F25C3E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M60.71 58.6265L60.767 136.222L163.133 194.726L163.137 116.441L108.62 119.237L60.71 58.6265Z",
    fill: "#E5E3E4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M108.63 128.546L163.141 194.72L60.776 136.211L108.63 128.546Z",
    fill: "#B8BDC0"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M107.082 137.41C106.543 137.579 105.963 137.346 105.672 136.843C105.672 136.843 61.45 58.9804 62.552 59.6434L162.665 116.464C163.6 117.027 107.082 137.41 107.082 137.41Z",
    fill: "#A3B5C9"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M162.264 117.525L107.09 134.129C106.551 134.291 105.971 134.067 105.681 133.585L60.895 59.2654C60.238 58.1754 61.4629 56.9274 62.5649 57.5634L162.525 115.279C163.459 115.818 163.297 117.213 162.264 117.525Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M186.827 88.7404L78.485 25.5254L78.548 113.347L186.823 175.229L186.827 88.7404Z",
    fill: "#F79E8D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M99.36 37.7056L111.265 44.6526L186.824 158.329V169.294L99.36 37.7056Z",
    fill: "#F25C3E"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M119.957 49.7246L131.863 56.6706L186.825 139.361V150.324L119.957 49.7246Z",
    fill: "#F25C3E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M186.827 101.421L186.826 112.385L161.153 73.7615L173.057 80.7065L186.827 101.421Z",
    fill: "#F25C3E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M140.555 61.7424L152.46 68.6894L186.826 120.391L186.825 131.355L140.555 61.7424Z",
    fill: "#F25C3E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M78.498 44.2614L78.491 33.2844L164.271 162.339L152.519 155.622L78.498 44.2614Z",
    fill: "#F25C3E"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M78.762 25.6875L90.667 32.6345L184.605 173.96L172.851 167.243L78.762 25.6875Z",
    fill: "#F25C3E"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M82.937 115.855L78.548 113.348L78.545 109.25L82.937 115.855Z",
    fill: "#F25C3E"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M181.75 85.7795L186.827 88.7405V93.4155L181.75 85.7795Z",
    fill: "#F25C3E"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M78.512 63.2516L78.504 52.2766L143.937 150.719L132.185 144.002L78.512 63.2516Z",
    fill: "#F25C3E"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M78.526 82.2436L78.5179 71.2666L123.605 139.099L111.851 132.381L78.526 82.2436Z",
    fill: "#F25C3E"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M78.54 101.236L78.532 90.2576L103.271 127.477L91.517 120.76L78.54 101.236Z",
    fill: "#F25C3E"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M81.446 34.0364L81.502 111.632L183.869 170.136L183.872 91.8514L129.355 94.6474L81.446 34.0364Z",
    fill: "#E5E3E4"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M129.365 103.956L183.876 170.129L81.511 111.621L129.365 103.956Z",
    fill: "#B8BDC0"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M127.818 112.821C127.279 112.99 126.699 112.757 126.408 112.254C126.408 112.254 82.186 34.3903 83.288 35.0543L183.402 91.8753C184.335 92.4373 127.818 112.821 127.818 112.821Z",
    fill: "#A3B5C9"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M182.999 92.9353L127.825 109.539C127.286 109.701 126.706 109.477 126.415 108.995L81.63 34.6753C80.973 33.5853 82.198 32.3373 83.3 32.9733L183.26 90.6893C184.195 91.2293 184.033 92.6233 182.999 92.9353Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M152.587 128.941L44.245 65.7263L44.309 153.547L152.583 215.429L152.587 128.941Z",
    fill: "#F79E8D"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M65.12 77.9053L77.026 84.8533L152.584 198.529L152.583 209.493L65.12 77.9053Z",
    fill: "#F25C3E"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M85.718 89.9243L97.6219 96.8703L152.584 179.56V190.524L85.718 89.9243Z",
    fill: "#F25C3E"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M152.586 141.622V152.585L126.913 113.961L138.818 120.906L152.586 141.622Z",
    fill: "#F25C3E"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M106.316 101.943L118.22 108.889L152.585 160.591V171.554L106.316 101.943Z",
    fill: "#F25C3E"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2579 84.4601L44.25 73.4841L130.031 202.539L118.279 195.822L44.2579 84.4601Z",
    fill: "#F25C3E"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M44.522 65.8872L56.428 72.8332L150.365 214.16L138.612 207.444L44.522 65.8872Z",
    fill: "#F25C3E"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M48.697 156.056L44.309 153.547L44.306 149.448L48.697 156.056Z",
    fill: "#F25C3E"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M147.51 125.979L152.587 128.941L152.586 133.616L147.51 125.979Z",
    fill: "#F25C3E"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M44.2729 103.452L44.264 92.4761L109.698 190.918L97.946 184.202L44.2729 103.452Z",
    fill: "#F25C3E"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M44.287 122.444L44.2789 111.466L89.365 179.298L77.6119 172.58L44.287 122.444Z",
    fill: "#F25C3E"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M44.3 141.435L44.292 130.457L69.031 167.677L57.278 160.959L44.3 141.435Z",
    fill: "#F25C3E"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M47.2059 74.2363L47.262 151.832L149.628 210.336L149.632 132.05L95.115 134.847L47.2059 74.2363Z",
    fill: "#E5E3E4"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M95.125 144.155L149.636 210.329L47.271 151.822L95.125 144.155Z",
    fill: "#B8BDC0"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M93.578 153.021C93.039 153.19 92.4589 152.957 92.1689 152.454C92.1689 152.454 47.9469 74.5902 49.0489 75.2542L149.162 132.075C150.096 132.638 93.578 153.021 93.578 153.021Z",
    fill: "#A3B5C9"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M148.76 133.134L93.5849 149.739C93.0459 149.901 92.466 149.677 92.176 149.196L47.39 74.8754C46.734 73.7854 47.959 72.5364 49.061 73.1734L149.021 130.889C149.954 131.429 149.793 132.823 148.76 133.134Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M141.305 139.947L32.963 76.7324L33.028 164.553L141.302 226.435L141.305 139.947Z",
    fill: "#F79E8D"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M53.838 88.9114L65.744 95.8594L141.302 209.534V220.499L53.838 88.9114Z",
    fill: "#F25C3E"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M74.436 100.93L86.3409 107.876L141.303 190.566L141.302 201.53L74.436 100.93Z",
    fill: "#F25C3E"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M141.304 152.627V163.591L115.631 124.967L127.536 131.912L141.304 152.627Z",
    fill: "#F25C3E"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0339 112.948L106.939 119.895L141.304 171.597L141.303 182.56L95.0339 112.948Z",
    fill: "#F25C3E"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9771 95.4663L32.969 84.4893L118.749 213.545L106.997 206.828L32.9771 95.4663Z",
    fill: "#F25C3E"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M33.241 76.8933L45.146 83.8393L139.083 225.166L127.329 218.449L33.241 76.8933Z",
    fill: "#F25C3E"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M37.415 167.062L33.028 164.553L33.025 160.454L37.415 167.062Z",
    fill: "#F25C3E"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M136.229 136.985L141.305 139.947V144.622L136.229 136.985Z",
    fill: "#F25C3E"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M32.991 114.457L32.983 103.482L98.415 201.924L86.663 195.207L32.991 114.457Z",
    fill: "#F25C3E"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M33.004 133.449L32.996 122.472L78.083 190.304L66.329 183.586L33.004 133.449Z",
    fill: "#F25C3E"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M33.019 152.441L33.01 141.463L57.749 178.683L45.995 171.965L33.019 152.441Z",
    fill: "#F25C3E"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M35.924 85.2415L35.981 162.838L138.347 221.342L138.351 143.056L83.833 145.853L35.924 85.2415Z",
    fill: "#E5E3E4"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M83.843 155.161L138.355 221.335L35.99 162.827L83.843 155.161Z",
    fill: "#B8BDC0"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M82.296 164.027C81.757 164.196 81.177 163.963 80.886 163.46C80.886 163.46 36.664 85.5963 37.766 86.2603L137.88 143.081C138.814 143.644 82.296 164.027 82.296 164.027Z",
    fill: "#A3B5C9"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M137.478 144.14L82.3039 160.745C81.7649 160.907 81.185 160.683 80.894 160.202L36.109 85.8805C35.452 84.7915 36.6769 83.5425 37.7789 84.1795L137.739 141.895C138.673 142.435 138.511 143.829 137.478 144.14Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M130.024 147.251L21.681 84.0354L21.745 171.858L130.02 233.738L130.024 147.251Z",
    fill: "#F79E8D"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M42.556 96.2166L54.462 103.163L130.021 216.84L130.02 227.804L42.556 96.2166Z",
    fill: "#F25C3E"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M63.155 108.235L75.059 115.182L130.021 197.871V208.834L63.155 108.235Z",
    fill: "#F25C3E"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M130.023 159.932V170.895L104.35 132.271L116.254 139.217L130.023 159.932Z",
    fill: "#F25C3E"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M83.752 120.252L95.658 127.198L130.022 178.901V189.864L83.752 120.252Z",
    fill: "#F25C3E"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6949 102.771L21.687 91.7944L107.468 220.849L95.715 214.133L21.6949 102.771Z",
    fill: "#F25C3E"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M21.958 84.1975L33.865 91.1445L127.801 232.471L116.048 225.753L21.958 84.1975Z",
    fill: "#F25C3E"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M26.134 174.366L21.745 171.859L21.743 167.76L26.134 174.366Z",
    fill: "#F25C3E"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M124.947 144.289L130.024 147.252L130.023 151.927L124.947 144.289Z",
    fill: "#F25C3E"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M21.709 121.762L21.701 110.785L87.134 209.229L75.382 202.512L21.709 121.762Z",
    fill: "#F25C3E"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M21.723 140.754L21.715 129.777L66.801 197.609L55.048 190.892L21.723 140.754Z",
    fill: "#F25C3E"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7369 159.745L21.729 148.768L46.467 185.988L34.714 179.271L21.7369 159.745Z",
    fill: "#F25C3E"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6429 92.5464L24.699 170.142L127.065 228.647L127.07 150.361L72.552 153.156L24.6429 92.5464Z",
    fill: "#E5E3E4"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M72.562 162.466L127.074 228.64L24.708 170.131L72.562 162.466Z",
    fill: "#B8BDC0"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M71.014 171.33C70.475 171.499 69.895 171.266 69.605 170.763C69.605 170.763 25.383 92.9003 26.485 93.5633L126.598 150.384C127.533 150.947 71.014 171.33 71.014 171.33Z",
    fill: "#A3B5C9"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M126.197 151.445L71.0229 168.05C70.4839 168.212 69.904 167.987 69.613 167.506L24.827 93.1853C24.171 92.0953 25.396 90.8473 26.498 91.4833L126.458 149.199C127.392 149.738 127.23 151.134 126.197 151.445Z",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M127.263 238.376L127.294 203.657L101.381 188.229C99.42 187.061 97.007 186.942 94.941 187.911L79.031 195.364C75.769 196.893 71.88 195.646 70.113 192.507L52.3309 160.889C51.7149 159.794 50.811 158.889 49.718 158.271L19.197 141.029V175.624L127.263 238.376Z",
    fill: "#B0847A"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M52.33 164.827L70.1119 196.444C71.8789 199.585 75.768 200.831 79.031 199.302L94.9399 191.848C97.0059 190.879 99.419 190.999 101.38 192.166L127.289 207.592L127.293 203.656L101.38 188.228C99.419 187.06 97.0059 186.941 94.9399 187.91L79.031 195.363C75.768 196.891 71.8789 195.645 70.1119 192.506L52.33 160.888C51.714 159.793 50.81 158.888 49.717 158.27L19.196 141.028V144.966L49.717 162.209C50.811 162.827 51.714 163.732 52.33 164.827Z",
    fill: "#FFC233"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M127.263 238.376L127.294 203.657L215.621 152.595V187.189L127.263 238.376Z",
    fill: "#85584E"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_727_30324",
    x1: 116.583,
    y1: 220.617,
    x2: 197.865,
    y2: 88.1577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.127,
    stopColor: "#A1A1BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8884,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRegulatorEscalatorImage);
export default __webpack_public_path__ + "static/media/regulatorEscalatorImage.289321ce0807d9cf7492b0ec00c30da4.svg";
export { ForwardRef as ReactComponent };